import { money } from "@/lib/api";
import { DemoBadge, Empty, ErrorBox, Meter, PageHead, Spinner, StatusBadge, useFetch } from "@/components/common";

const Breakdown = ({ title, data, testId }) => (
  <div className="surface p-5" data-testid={testId}>
    <h3 className="mb-3 text-sm font-bold">{title}</h3>
    {Object.keys(data).length === 0 ? <p className="text-xs text-slate-400">No records</p> : (
      <div className="space-y-2">{Object.entries(data).map(([k, v]) => (
        <div key={k} className="flex items-center justify-between text-sm"><StatusBadge status={k} /><span className="font-mono font-semibold">{v}</span></div>
      ))}</div>
    )}
  </div>
);

export default function Reports() {
  const { data: r, error, loading } = useFetch("/admin/reports");
  if (loading) return <Spinner />;
  if (!r) return <ErrorBox error={error} />;
  return (
    <div className="space-y-6">
      <PageHead eyebrow="Reports" title="Operational reports" />
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        <Breakdown title="Card inventory" data={r.cards} testId="report-cards" />
        <Breakdown title="Package activations" data={r.activations} testId="report-activations" />
        <Breakdown title="Service requests" data={r.service_requests} testId="report-requests" />
        <Breakdown title="Insurance enrollments" data={r.insurance} testId="report-insurance" />
      </div>
      <section className="surface overflow-x-auto" data-testid="report-utilization">
        <h3 className="p-5 pb-2 text-sm font-bold">Benefit utilization</h3>
        {r.utilization.length === 0 ? <div className="p-5"><Empty title="No entitlements generated yet" /></div> : (
          <table className="data-table">
            <thead><tr><th>Benefit</th><th>Type</th><th>Entitlements</th><th>Used / Included</th><th className="w-48">Remaining</th></tr></thead>
            <tbody>{r.utilization.map((u) => (
              <tr key={`${u.benefit}-${u.is_demo}`}>
                <td className="font-semibold">{u.benefit}</td><td>{u.is_demo ? <DemoBadge /> : "Real"}</td><td>{u.entitlements}</td>
                <td className="font-mono">{u.used} / {u.included}</td><td><Meter used={u.used} total={u.included} /></td>
              </tr>
            ))}</tbody>
          </table>
        )}
      </section>
      <section className="surface overflow-x-auto" data-testid="report-payments">
        <h3 className="p-5 pb-2 text-sm font-bold">Paid transactions</h3>
        {r.payments.length === 0 ? <div className="p-5"><Empty title="No paid transactions" /></div> : (
          <table className="data-table">
            <thead><tr><th>Mode</th><th>Method</th><th>Count</th><th>Total</th></tr></thead>
            <tbody>{r.payments.map((p) => (
              <tr key={`${p.mode}-${p.method}`}><td>{p.mode === "DEMO" ? <DemoBadge /> : "LIVE"}</td><td>{p.method}</td><td>{p.count}</td><td className="font-semibold">{money(p.total)}</td></tr>
            ))}</tbody>
          </table>
        )}
      </section>
    </div>
  );
}
